import styled from '@emotion/styled'
import { HTMLAttributes } from 'react'

interface HeaderProps {
  name: string
  parentUrl: string
}

type StyledHTMLElement = React.DetailedHTMLProps<
  HTMLAttributes<HTMLElement>,
  HTMLElement
>

export const Header: React.FC<HeaderProps> = ({ ...props }) => {
  const { name } = props
  return (
    <Container id='product-modal-header' paddingBottom='8px'>
      <Name>{name}</Name>
    </Container>
  )
}

const Name = styled.h1<StyledHTMLElement>(({ theme }) => ({
  fontSize: theme.fontSizes[3],
  color: theme.colors['textBold'],
  flex: '1 0 80%',
  padding: `${theme.space[4]}px ${theme.space[7]}px 0 0`,
  [theme.mediaQueries.viewport7]: {
    fontSize: theme.fontSizes[5]
  }
}))

const Container = styled.div<StyledHTMLElement & { paddingBottom?: string }>(
  ({ paddingBottom }) => ({
    top: 0,
    paddingBottom: paddingBottom,
    backgroundColor: 'white',
    position: 'sticky',
    zIndex: 1
  })
)
